import { z } from 'zod'

export const getFormConfig = (translations: (arg0: string) => any) => {
  const t = (key: string) => translations(key)

  const formConfig = {
    id: 'help-form',
    fields: [
      {
        name: 'message',
        label: t('HELP.MESSAGE.LABEL'),
        placeholder: t('HELP.MESSAGE.PLACEHOLDER'),
        type: 'text-area',
        required: true,
        validation: z
          .string({
            required_error: t('HELP.MESSAGE.VALIDATION.REQUIRED')
          })
          .trim()
          .min(1)
      }
    ],
    onSubmit: (data: Record<string, any>) => {
      console.log('Form submitted:', data)
    }
  }
  return formConfig
}
